module.exports = __webpack_public_path__ + "img/advanced.8f88b323.png";